import { Fragment } from 'react';
import Link from '@v2/shared/components/Link';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  authors: string[];
};

/**
 * "Smith, John", or "Smith, John & Doe, Jane", or "A, B & C" — each name a search for
 * everything else they wrote.
 *
 * The separator is the interesting part: comma between all but the last pair, ampersand
 * before the final name. Authors arrive spelled "Surname, Forename", so a comma-only
 * list would read as one very long name.
 */
export default function Authors({ authors }: Props) {
  const { buildUrl } = useUrlGenerator();

  return (
    <>
      {authors.map((author, index) => (
        <Fragment key={`${author}-${index}`}>
          <Link
            className="text-red-600 hover:underline"
            href={buildUrl(`/search?xSearch=${encodeURIComponent(author)}&fields[]=authors`)}
          >
            {author}
          </Link>
          {index < authors.length - 1 && (index === authors.length - 2 ? <> &amp; </> : <>, </>)}
        </Fragment>
      ))}
    </>
  );
}
